<template>
  <div class="container">
    <v-row class="page-header">
      <v-col class="page-title" cols="12">
        <v-toolbar-title class="font-bold">{{ $t('lbl.filters.pageHeader') }}</v-toolbar-title>
      </v-col>
    </v-row>
    <v-row class="custom-form-control custom-form-control-type-2 custom-figma-1">
      <v-col cols="12" class="pt-0 pb-0">
        <v-row>
          <v-col
            class="comm-header-col data-query-section pb-0 pt-0 mt-0 custom-figma-1"
            cols="12"
            lg="8"
            md="8"
          >
            <v-row>
              <v-col cols="12" lg="4" md="3" class="pt-0 pb-0">
                <v-text-field
                  v-model="fltrNm"
                  @keyup.enter.native="searchItem"
                  :label="$t('lbl.common.conditionSearch.findbyName')"
                  class="custom-selectbox"
                  hide-details
                  dense
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="12" lg="2" md="3" class="pt-0 pb-0">
                <v-autocomplete
                  v-model="fltrTpCd"
                  :items="getTypeList"
                  :menu-props="{ offsetY: true }"
                  :label="$t('lbl.common.conditionSearch.selectType')"
                  @change="searchItem"
                  class="custom-selectbox"
                  hide-details
                  dense
                  filled
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" lg="6" md="3" class="pt-0 pb-0">
                <v-text-field
                  v-model="srcPttn"
                  @keyup.enter.native="searchItem"
                  :label="$t('lbl.common.conditionSearch.filterPattern')"
                  class="custom-selectbox"
                  hide-details
                  dense
                  filled
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <v-col
            class="comm-header-col date-query-section pb-0 pt-0 pr-0 mt-0 text-right custom-figma-1"
            cols="12"
            lg="4"
            md="4"
          >
            <div class="pl-0 pt-0 pb-0 d-inline-flex btn-control"></div>
            <div class="pl-0 pt-0 pb-0 d-inline-flex btn-control">
              <v-btn class="btn btn-search btn-width-1" color="primary" @click.native="searchItem">
                <v-icon x-small class="mr-2">fa fa-search</v-icon>{{ $t('btn.common.search') }}
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="custom-pagination-figma-v3-first">
      <v-col class="page-control-content page-control-bg">
        <v-row>
          <v-col lg="6" md="6">
            <v-row>
              <v-col class="page-control-bg" cols="12">
                <v-btn
                  @click="openFilterWindow(null, 'Add')"
                  :disabled="!$auth.manage"
                  class="btn btn-add"
                >
                  {{ $t('btn.common.add') }}
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
          <v-col lg="2" md="1"></v-col>
          <v-col lg="4" md="5" class="filter-search">
            <v-row>
              <v-col class="mr-0 pr-0 pl-0" lg="5" md="5">
                <v-select
                  v-model="searchBy"
                  :items="searchByItems"
                  :placeholder="$t('lbl.common.searchTypePlaceHolder')"
                  @change="onSearchFilter"
                  class="search-by data-table-select-box custom-selectbox pla-col mr-0 flat-file-selectbox"
                  height="40"
                  hide-details
                  dense
                  solo
                ></v-select>
              </v-col>
              <v-col class="ml-0 pl-0" cols="12" md="7">
                <v-text-field
                  v-model="search"
                  :placeholder="$t('lbl.common.searchPlaceHolder')"
                  @input="onSearchFilter"
                  @click:append="onSearchFilter"
                  @keyup.enter="onSearchFilter"
                  class="data-table-filter-text-field search-button-data-analysis-table flat-file"
                  heigth="40"
                  append-icon="fa fa-search"
                  hide-details
                  dense
                  solo
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <system-progress :sysloading="isLoading" :sysloadingTitle="sysloadingTitle"></system-progress>
      <v-col cols="12" class="pt-0 pb-0">
        <v-data-table
          :headers="headers"
          :items="listData"
          :page.sync="page"
          :hide-default-footer="true"
          :items-per-page="itemsPerPage"
          :fixed-header="true"
          :height="tableHeight"
          @page-count="pageCount = $event"
          :class="[
            'list-table code-table srm-list-table custom-border-table',
            totalCnt > 0 ? '' : 'custom-border-table-not-data',
          ]"
          no-data-text="No matching records found"
        >
          <template v-slot:body="{ items }">
            <tbody>
              <tr
                v-for="item in items"
                :key="item.id"
                @click="onClickRow(item)"
                :class="[selectedRow === item.fltrId ? 'selected_row' : '']"
              >
                <td class="index-col">{{ listData.indexOf(item) + 1 }}</td>
                <td class="col-name">{{ item.fltrNm }}</td>
                <td>{{ item.fltrTpCdNm }}</td>
                <td>{{ item.srcPttn }}</td>
                <td class="text-center">
                  <v-btn
                    small
                    text
                    icon
                    @click="openFilterWindow(item, 'Edit')"
                    :disabled="!$auth.manage"
                  >
                    <icon-svg :disabled="!$auth.manage" iconName="edit" />
                  </v-btn>
                  <v-btn
                    :disabled="!$auth.manage"
                    @click="openFilterWindow(item, 'Copy')"
                    small
                    text
                    icon
                  >
                    <icon-svg :disabled="!$auth.manage" iconName="copy" />
                  </v-btn>
                  <v-btn small text icon @click="deleteItem(item)" :disabled="!$auth.manage">
                    <icon-svg :disabled="!$auth.manage" iconName="delete" />
                  </v-btn>
                </td>
                <td class="text-center">{{ item.updDt }}</td>
                <td>{{ item.updUsrId }}</td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-row v-show="totalCnt > 0" class="custom-pagination-figma-v3-last">
      <v-col class="page-control-content page-control-bg transaction-pagi">
        <v-row>
          <v-col lg="12" md="12">
            <v-row>
              <v-col class="page-control-bg text-left pa-0" cols="6">
                <div class="custom-pagi-selectbox">
                  <v-select
                    v-model="itemsPerPage"
                    hide-details
                    dense
                    solo
                    :items="rowPerPage"
                    class="data-table-select-box custom-selectbox mr-0 page-flat-file-selectbox"
                  >
                  </v-select>
                </div>
              </v-col>
              <v-col class="page-control-bg text-right pa-0" cols="6">
                <div class="page-showing">
                  <v-label>
                    {{ itemsPerPage * (page - 1) + 1 }} ~
                    {{ totalCnt - itemsPerPage * page > 0 ? itemsPerPage * page : totalCnt }}
                    of {{ totalCnt }}
                  </v-label>
                </div>
                <button
                  type="button"
                  @click="handlePageChange(1)"
                  :class="[
                    'custom-btn-first-last-paging',
                    page == 1 ? ' v-pagination__navigation--disabled' : '',
                  ]"
                >
                  <div class="ml-2 pr-2 d-inline">
                    <span><i class="fa fa-sm fa-step-backward"></i></span>
                  </div>
                </button>
                <button
                  type="button"
                  @click="changePageByTextbox(-1)"
                  :class="[
                    'mr-3 custom-btn-first-last-paging',
                    page - 1 < 1 ? ' v-pagination__navigation--disabled' : '',
                  ]"
                >
                  <div class="ml-2 pr-2 d-inline">
                    <span><i class="fa fa-lg fa-caret-left"></i></span>
                  </div>
                </button>
                <v-text-field
                  v-model="pageEnter"
                  hide-details
                  dense
                  solo
                  class="data-table-filter-text-field custom-pagi-selectbox page-selectbox"
                  @keyup.enter="changePageByTextbox(0)"
                ></v-text-field
                ><label>/ {{ pageCount }}</label>
                <button
                  type="button"
                  @click="changePageByTextbox(1)"
                  :class="[
                    'ml-3 custom-btn-first-last-paging',
                    page + 1 > pageCount ? ' v-pagination__navigation--disabled' : '',
                  ]"
                >
                  <div class="mr-2 pl-2 d-inline">
                    <span><i class="fa fa-lg fa-caret-right"></i></span>
                  </div>
                </button>
                <button
                  type="button"
                  @click="handlePageChange(pageCount)"
                  :class="[
                    'custom-btn-first-last-paging',
                    page == pageCount ? ' v-pagination__navigation--disabled' : '',
                  ]"
                >
                  <div class="mr-2 pl-2 d-inline">
                    <span><i class="fa fa-sm fa-step-forward"></i></span>
                  </div>
                </button>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <div v-for="dialog in dialogs" :key="dialog.id" class="dialogs">
      <AddFilterLayout
        v-if="dialog.type == 'addFilterLayout'"
        :id="dialog.id"
        :ref="'dialog-' + dialog.id"
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :options="dialog.options"
        :paramItem="ediItems"
        :refeshList="searchItem"
      ></AddFilterLayout>
      <versionHistory
        v-if="dialog.type == 'versionHistory'"
        class="custom-dialog mapper-version"
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :options="dialog.options"
        :id="dialog.id"
        title="Filter"
      ></versionHistory>
    </div>
    <dialogWindow
      ref="deleteDialog"
      :info="editedItem.fltrNm"
      size="max"
      title="Delete Filter"
      :detail="$t('msg.common.infoConfirm.detail', ['delete the filter'])"
      color="confirmation"
      :showCancel="true"
      @select-ok="onDeleteItem(editedItem)"
    ></dialogWindow>
  </div>
</template>

<script>
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';
import SystemProgress from '@/vue-dlb/components/SystemProgress.vue';
import AddFilterLayout from '@/vue-caas/views/filter/FilterAdd.vue';
import versionHistory from '@/vue-caas/components/DelHistoryWorkflowDialog.vue';
import $ from 'jquery';
import { mapState } from 'vuex';
import { resizeTableHeight } from '@/vue-dlb/common/common';
// 2021.12.1 SPKA-297 svg icon
import IconSvg from '@/vue-caas/components/IconBase.vue';
import cfg from '@/vue-caas/config/config.js';
import EventBus from '@/vue-caas/views/process/component/event-bus.js';

export default {
  components: {
    SystemProgress,
    AddFilterLayout,
    versionHistory,
    dialogWindow,
    IconSvg, // 2021.12.1 SPKA-297 svg icon
  },
  data() {
    return {
      editedItem: {
        fltrNm: '',
        fltrTpCd: '',
        srcPttn: '',
      },
      fltrNm: '',
      fltrTpCd: '',
      srcPttn: '',
      types: [],
      fltrTpCdList: [],
      listData: [],
      page: 1,
      pageCount: 0,
      itemsPerPage: 50,
      tableHeight: '',
      search: '',
      searchBy: 'all',
      selectedRow: '',
      isCreated: false,
      isLoading: false,
      dialogs: [],
      dialogId: 1,
      arrLayoutDialog: [],
      ediItems: null,
      totalCnt: 0,
      pageEnter: 1,
      headers: [
        { text: this.$t('tbl.common.columnNo'), value: 'INDEX', width: '60px' },
        { text: 'Name', value: 'fltrNm', width: '255px' },
        { text: 'Type', value: 'fltrTpCd', align: 'center', width: '290px' },
        { text: 'Pattern', value: 'srcPttn' },
        {
          text: 'Manage',
          value: 'manage',
          align: 'center',
          width: '120px',
          sortable: false,
        },
        {
          text: 'Last Update',
          value: 'updDt',
          align: 'center',
          width: '180px',
        },
        {
          text: 'Update User',
          value: 'updUsrId',
          align: 'left',
          width: '230px',
        },
      ],
      searchByItems: [
        { text: this.$t('lbl.common.searchTypePlaceHolder'), value: 'all' },
        { text: 'Name', value: 'fltrNm' },
        { text: 'Type', value: 'fltrTpCdNm' },
        { text: 'Pattern', value: 'srcPttn' },
      ],
      rowPerPage: [
        { value: 10, text: 'Show 10' },
        { value: 25, text: 'Show 25' },
        { value: 50, text: 'Show 50' },
        { value: 75, text: 'Show 75' },
        { value: 100, text: 'Show 100' },
      ],
    };
  },
  methods: {
    searchItem() {
      this.isLoading = true;
      const params = {
        fltrNm: this.fltrNm,
        fltrTpCd: this.fltrTpCd,
        srcPttn: this.srcPttn,
      };
      this.$store
        .dispatch('getFilterList', params)
        .then(() => {
          this.listData = this.$store.getters.filterList;
          this.listData.map((e) => {
            let index = this.types.findIndex((r) => r.value === e.fltrTpCd);
            e.fltrTpCdNm = index > -1 ? this.types[index].text : '';
          });
          this.isLoading = false;
          this.totalCnt = this.listData.length;
          this.caculatePageCount();
        })
        .catch((ex) => {
          this.isLoading = false;
        });
    },
    caculatePageCount() {
      if (this.totalCnt % this.itemsPerPage === 0) {
        this.pageCount = this.totalCnt / this.itemsPerPage;
      } else {
        this.pageCount = Math.floor(this.totalCnt / this.itemsPerPage) + 1;
      }
    },
    openFilterWindow(itemRow, typeActive) {
      let isEdit = false;

      if (typeActive == 'Edit') {
        this.ediItems = Object.assign({}, itemRow);
        this.ediItems.action = 'Edit';
        isEdit = true;
      } else if (typeActive == 'Copy') {
        this.ediItems = Object.assign({}, itemRow);
        this.ediItems.fltrNm = '';
        this.ediItems.action = 'Copy';
        isEdit = true;
      } else {
        this.ediItems = {};
        this.ediItems.action = 'Add';
        isEdit = false;
      }
      let type = 'addFilterLayout';
      let item = {
        ROWID: 0,
        isEdit: isEdit,
      };
      let indexArrDialog = this.findDialog('addFilterLayout_0');
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
      // this.searchItem();
    },
    findDialog(id, dialogs) {
      if (!dialogs) dialogs = this.dialogs;
      let index = dialogs.findIndex((val) => {
        return val.id === id;
      });
      return index > -1 ? index : null;
    },
    newDialog(item, type) {
      return this.dialogs.push(this.generateDialog(item, type));
    },
    generateDialog(item, type) {
      let id = `${type}_${item.ROWID}`;
      this.arrLayoutDialog.push({ id: id });
      this.dialogId++;
      let name = 'Dialog ' + id;
      let options = { left: 30 * this.dialogId, top: 30 * this.dialogId, item };
      return { id, name, type, options };
    },
    removeDialog(dialog) {
      let id = dialog.id;
      let index = this.findDialog(id);
      let indexArrDialog = this.findDialog(id, this.arrLayoutDialog);
      this.arrLayoutDialog.splice(indexArrDialog, 1);
      this.dialogs.splice(index, 1);
      if (this.selected && this.selected.id === id) this.selected = null;
    },
    dialogDragEnd(obj) {
      let index = this.findDialog(obj.id);
      this.$set(this.dialogs[index].options, 'left', obj.left);
      this.$set(this.dialogs[index].options, 'top', obj.top);
    },
    selectDialog(obj) {
      let index = this.findDialog(obj.id);
      this.selected = this.dialogs[index];
    },
    openVersionHistory(versionList, val) {
      let type = 'versionHistory';
      let item = {};
      item.ROWID = 0;
      item.versionList = versionList;
      item.comNm = val.prnrNm;
      item.item = val;
      let indexArrDialog = this.findDialog('versionHistory_0');
      if (indexArrDialog != null) {
        this.dialogs[indexArrDialog].options.item = item;
        return;
      }
      this.newDialog(item, type) - 1;
    },
    onSearchFilter(str) {
      setTimeout(() => {
        this.$store
          .dispatch('setSearchFilter', {
            searchBy: this.searchBy,
            str: this.search,
          })
          .then(() => {
            this.listData = this.$store.getters.filterList;
            this.totalCnt = this.listData.length;
            this.caculatePageCount();
          });
      }, 300);
    },
    onClickRow(item) {
      this.selectedRow = item.fltrId;
    },
    deleteItem(item) {
      this.editedItem = Object.assign({}, item);
      let self = this;
      if (cfg.isDlb) {
        self.$refs.deleteDialog.dialog = true;
      } else {
        this.$store
          .dispatch('getListUseInWorkflow', {
            type: 'COM',
            value: this.editedItem.fltrId,
          })
          .then((res) => {
            if (res.length > 0) {
              self.openVersionHistory(res, item);
            } else {
              self.$refs.deleteDialog.dialog = true;
            }
          });
      }
    },
    onDeleteItem(item) {
      this.$store.dispatch('deleteFilter', item).then(() => {
        this.searchItem();
      });
    },
    // 2021.11.23 213960 modify page function: change page and change page size
    changePageByTextbox(value) {
      let data = parseInt(this.pageEnter);
      if (isNaN(data)) {
        this.pageEnter = this.page;
        return;
      } else {
        this.page = data > this.pageCount ? this.pageCount : data < 1 ? 1 : data;
        this.pageEnter = this.page;
      }
      this.page += value;
    },
    handlePageChange(value) {
      this.page = value;
    },
  },
  computed: {
    getTypeList() {
      this.types = [{ text: this.$t('lbl.common.conditionSearch.all'), value: '' }];
      for (let i = 0; i < this.fltrTpCdList.length; i++) {
        this.types.push(this.fltrTpCdList[i]);
      }
      return this.types;
    },
    ...mapState('common', {
      sysloadingTitle: 'sysloadingTitle',
    }),
  },
  async created() {
    await this.$store.dispatch('caascommon/getComCdList', { grpCd: 'P05' }).then(() => {
      this.fltrTpCdList = this.$store.getters['caascommon/comCdList'];
    });
    this.searchItem();
    EventBus.$on('delete-item', this.onDeleteItem);
    this.isCreated = true;
  },
  watch: {
    listData() {
      return this.listData;
    },
    page() {
      this.pageEnter = this.page;
    },
  },
  updated: function() {
    let self = this;
    let arrClassMinus = ['.page-control-content'];
    let arrClassPlus = [];

    if (this.isCreated) {
      let h1 = resizeTableHeight(arrClassMinus, arrClassPlus, true);
      self.tableHeight = h1 + 'px';
      this.isCreated = false;
    }

    $(window).resize(function(event) {
      let h1 = resizeTableHeight(arrClassMinus, arrClassPlus, true);
      self.tableHeight = h1 + 'px';
    });
  },
  mounted() {
    window.addEventListener('storage', (event) => {
      if (event.key === 'processSharedData') {
        const updatedState = JSON.parse(event.newValue);
        if (updatedState?.FLT) {
          this.searchItem();
        }
      }
    });
  },
};
</script>
